<template>
  <div id="app">
    <Loading :isLoading="isLoading" />
    <div class="layout">
      <!-- Preloader -->
      <div class="preloader">
        <div class="preloader__image" style="background-image: url(@/assets/images/loader.png);"></div>
      </div>

      <!-- Header -->
      <TopBar />
      <HeaderView />
      <Breadcrumbs />
      <HeaderNavigation v-if="isDesktop" />
      <MobileMenu v-if="!isDesktop" :menuOpen="mobileMenuOpen" @toggle-menu="toggleMobileMenu" />


      <!-- Conteúdo principal -->
      <router-view />

      <!-- Área mobile e rodapé -->
      <MobileArea />
    </div>
    <FooterView />

    <!-- Carrinho -->
    <CartView ref="cart" />
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, computed } from 'vue';
import { useStore } from 'vuex';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faBars, faChevronLeft, faShoppingCart } from '@fortawesome/free-solid-svg-icons';

import TopBar from './components/home/TopBar.vue';
import HeaderView from './components/home/HeaderView.vue';
import Breadcrumbs from './components/template/breadcrumbs.vue';
import MobileArea from './components/home/MobileArea.vue';
import FooterView from './components/home/FooterView.vue';

import CartView from './views/ecommerce/CartView.vue';
import Loading from './components/template/loading-spinner.vue';
import { eventBus } from './eventBus';

library.add(faBars, faChevronLeft, faShoppingCart);

export default {
  name: 'App',
  components: {
    TopBar,
    HeaderView,
    Breadcrumbs,
    MobileArea,
    FooterView,
   
    FontAwesomeIcon,
    CartView,
    Loading
  },
  setup() {
    const store = useStore();
    const isDesktop = ref(window.innerWidth > 991);
    const mobileMenuOpen = ref(false);
    const updateInterval = 3 * 60 * 1000;
    let intervalId;

    const isLoading = computed(() => store.getters['general/getIsLoading']);

    const startUpdating = () => {
      intervalId = setInterval(() => {
        store.dispatch('fetchCategories');
      }, updateInterval);
    };

    const loadCartWithDelay = () => {
      setTimeout(() => {
        store.dispatch('ecommerce/getCart');
      }, 500);
    };

    const handleResize = () => {
      isDesktop.value = window.innerWidth > 991;
    };

    const toggleMobileMenu = () => {
      mobileMenuOpen.value = !mobileMenuOpen.value;
      document.body.style.overflow = mobileMenuOpen.value ? 'hidden' : '';
    };

    onMounted(() => {
      store.dispatch('general/fetchStartData');
      startUpdating();
      window.addEventListener('resize', handleResize);
      handleResize();
      loadCartWithDelay();
    });

    onUnmounted(() => {
      clearInterval(intervalId);
      window.removeEventListener('resize', handleResize);
    });

    return {
      isDesktop,
      mobileMenuOpen,
      toggleMobileMenu,
      isLoading
    };
  },
  methods: {
    openCart() {
      eventBus.emit('toggle-cart');
    }
  }
}
</script>

<style scoped>
#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.layout {
  flex: 1;
}
.preloader {
  display: none; /* Configure conforme necessário */
}
.hamburger-btn {
  position: absolute;
  top: 80px;
  left: 10px;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: 40px;
  padding: 0;
  font-size: 24px;
  color: #333;
  z-index: 9000;
  transition: color 0.3s;
}
.hamburger-btn:hover {
  color: #E23B33;
}
.cart-btn {
  position: fixed;
  top: 60px;
  right: 16px;
  background-color: #E23B33;
  border: none;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  z-index: 1300;
}
.cart-btn:hover {
  background-color: #b58447;
}
</style>
